import React, { PureComponent } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import AccordionBody from './AccordionBody';
import AccordionHeader from './AccordionHeader';
import AccordionToggle from './AccordionToggle';

import './Accordion.scss';

export default class Accordion extends PureComponent {
  static Toggle = AccordionToggle;
  static Body = AccordionBody;
  static Header = AccordionHeader;

  state = {
    opened: this.props.opened || false
  };

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    opened: PropTypes.bool,
    onToggle: PropTypes.func
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      JSON.stringify(nextProps.opened) !== JSON.stringify(prevState.opened) &&
      nextProps.onToggle
    ) {
      return { opened: nextProps.opened };
    }

    return null;
  }

  toggle = () => {
    this.setState((prevState) => ({ opened: !prevState.opened }));
  };

  render() {
    const { children, className } = this.props;
    const { opened } = this.state;

    const classComponent = classNames(
      'accordion',
      { 'accordion--open': opened },
      className
    );

    return (
      <div className={classComponent} data-test="ca-accordion">
        {React.Children.map(children, this.renderChildren)}
      </div>
    );
  }

  renderChildren = (element) => {
    const { opened } = this.state;
    const { onToggle } = this.props;

    if (!element) {
      return;
    }

    if (element.type === AccordionToggle || element.type === AccordionHeader) {
      return React.cloneElement(element, {
        onToggle: onToggle ? onToggle : this.toggle,
        opened
      });
    }

    if (element.type === AccordionBody) {
      return React.cloneElement(element, { opened });
    }
  };
}
